export const CONFIG_DEV = {
  MODE: 'dev',
  ENDPOINT: ['powersports-redesign-html.box.gravityapps.net', 'localhost'].includes(window.location.hostname) ? 'https://hondaps-redesign-cm.sc.gravity.codes' : '',
  ENDPOINT_IMAGE: 'https://hondaps-redesign-cm.sc.gravity.codes/',
};
